// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import { apiLink } from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

export const getMedia = createAsyncThunk('appDocuments/getMedia', async ({ types, company_id }) => {
   const response = await axios.post(apiLink('getFiles', {typeOwner: 'DOCUMENT_TEMPLATE'}), { types, ids: [company_id] })
   return { files: response.data.files }
})
export const addMedia = createAsyncThunk('appDocuments/addMedia', async ({ company_id, type, typeOwner, file }) => {
   const response = await axios({
         method: "post",
         url: apiLink({ name: 'uploadFile', value: company_id }, { type, typeOwner }),
         data: { file },
         headers: { "Content-Type": "multipart/form-data" }         
      })
   return response.data
})
export const removeMedia = createAsyncThunk('appDocuments/removeMedia', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeFile', value: id}, {typeOwner: 'DOCUMENT_TEMPLATE'}))
   return {id, status: response.status}
})

export const generateDocumentFromFile = createAsyncThunk('appDocuemnts/generateDocumentFromFile', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/documents/generate?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** External field placeholders
export const getExternalFieldPlaceholders = createAsyncThunk('appDocuments/getExternalFieldPlaceholders', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/external-fields/placeholders?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

export const appDocumentsSlice = createSlice({
   name: 'appDocuments',
   initialState: {
      media: []
   },
   extraReducers: builder => {
      builder
         .addCase(getMedia.fulfilled, (state, action) => {
            state.media = [...state.media, ...action.payload.files].reduce((accumulator, current) => {
               if (!accumulator.find((item) => item.file_id === current.file_id)) {
                  accumulator.push(current)
               }
               return accumulator
            }, [])
         })
         .addCase(removeMedia.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
               state.media = state.media.filter(item => item.file_id !== action.payload.id)
            }
         })
   }
})

export default appDocumentsSlice.reducer
